import { render, staticRenderFns } from "./JImageNote.vue?vue&type=template&id=73e505dc&scoped=true"
import script from "./JImageNote.vue?vue&type=script&lang=ts"
export * from "./JImageNote.vue?vue&type=script&lang=ts"
import style0 from "./JImageNote.vue?vue&type=style&index=0&id=73e505dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e505dc",
  null
  
)

export default component.exports